import React, { useState, useEffect, useRef } from "react";
import { Button, Row } from "react-bootstrap";
import { Icon } from "semantic-ui-react";

const CourseDetailsScrollStrip = ({ courseDetails = [] }) => {
  const [scrollStartOrEnd, setScrollStartOrEnd] = useState(null);
  const scrollRef = useRef();

  const handleNav = (direction) => {
    if (!scrollRef?.current) return;

    const remainingScrollWidth = scrollRef.current.scrollWidth - scrollRef.current.scrollLeft;

    scrollRef.current.scrollBy({
      left: direction === "left" ? -remainingScrollWidth : remainingScrollWidth,
      behavior: "smooth",
    });
  };

  const handleScroll = () => {
    const container = scrollRef.current;
    if (!container) return;

    const { scrollLeft, scrollWidth, clientWidth } = container;

    if (scrollWidth <= clientWidth) {
      setScrollStartOrEnd("no-scroll");
    } else if (scrollLeft === 0) {
      setScrollStartOrEnd("start");
    } else if (scrollLeft + clientWidth >= scrollWidth - 1) {
      setScrollStartOrEnd("end");
    } else {
      setScrollStartOrEnd(null);
    }
  };

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    handleScroll();
    container.addEventListener("scroll", handleScroll);

    const handleResize = () => {
      handleScroll();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      container.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const courseDetailsHeaders = courseDetails.map((courseDetail, index) => (
    <div
      key={`${courseDetail.key}-${index}`}
      className={`${index !== courseDetails.length - 1 ? "manage-course-info" : ""} px-4`}
      xs="auto"
    >
      <h4 className="course-details-title font-weight-bold mb-0">{courseDetail.key}</h4>
      <div className="course-details-content">{courseDetail.value}</div>
    </div>
  ));

  return (
    <Row className="manage-course-info-container mb-3">
      {scrollStartOrEnd !== "start" && scrollStartOrEnd !== "no-scroll" && (
        <Button className="arrow-btn left" variant="none" onClick={() => handleNav("left")}>
          <Icon name="chevron left" />
        </Button>
      )}
      <div ref={scrollRef} className="manage-course-info-container d-flex">
        {courseDetailsHeaders}
      </div>
      {scrollStartOrEnd !== "end" && scrollStartOrEnd !== "no-scroll" && (
        <Button className="arrow-btn right" variant="none" onClick={() => handleNav("right")}>
          <Icon name="chevron right" />
        </Button>
      )}
    </Row>
  );
};

export default CourseDetailsScrollStrip;
